import { observable, action, computed } from 'mobx'
import { Store } from 'libx'

export default class BookkeepingPlatformConnectionsDialogStore extends Store {
  @observable
  showing = false

  @observable
  success = false

  @observable
  platform = ''

  /**
   * Accounts for the selected platform
   */
  @computed
  get accounts() {
    return this.platform === 'QuickBooks'
      ? this.rootStore.bookkeepingPlatformConnectionStore.quickBooksAccounts
      : this.rootStore.bookkeepingPlatformConnectionStore.xeroAccounts
  }

  /**
   * Scroll provider for the selected platform
   */
  @computed
  get scrollProvider() {
    return this.rootStore.bookkeepingPlatformConnectionStore.getScrollProvider(
      this.platform,
      (params) => this.fetchItems(params)
    )
  }

  @action
  async show(platform) {
    this.platform = platform
    this.showing = true
  }

  @action
  close() {
    this.showing = false
    this.success = false
  }

  /**
   * Fetches items for the selected platform
   *
   * @param {*} params
   */
  async fetchItems(params) {
    const store = this.rootStore.bookkeepingPlatformConnectionStore

    return this.platform === 'QuickBooks'
      ? await store.fetchQuickBooksPlatformConnections(params)
      : await store.fetchXeroPlatformConnections(params)
  }

  addManualConnection() {
    this.rootStore.bookkeepingAddManualConnectionStore.show()
    this.close()
  }
}
